export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxUl0c6SjTjQJElg.2ef6d728.woff2";